


<app-add-comment  [iComment]= addComment()> </app-add-comment>